import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

import UploadBadge from "../../components/UploadBadge";
import UploadAudio from "../../components/UploadAudio";
import { createAudio, updateAudio } from "../../http/audio";
import Spinner from "../../components/Spinner";
import { toast } from "react-toastify";
import { handleToast } from "../../utils/common";
import CustomMultiSelect from "../../components/FormElements/MultiSelect";
import CustomTextField from "../../components/FormElements/CustomTextField";
import { uploadImage } from "../../http/uploads";
import OutlinedButton from "../../components/FormElements/Buttons/OutlinedButton";
import ContainedButton from "../../components/FormElements/Buttons/ContainedButton";
import AxiosInstance from "../../services/networkServices";
import { useDispatch } from "react-redux";
import { setLoading, showToast } from "../../store/slices/common";
import DateTimeRangePicker from "../../components/FormElements/DateTimeRangePicker";
// import { Select } from "antd";
import dayjs from "dayjs";

const AddEditBattle = ({
  openDialog,
  handleCloseDialog,
  selectedItem,
  edit,
  fetchList,
}) => {
  console.log(selectedItem, "selectedItem");
  const [image, setImage] = useState(null);
  const [title, setTitle] = useState(selectedItem?.title || "");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  // Turn length is server-enforced at 15s; the API rejects any other value.
  const [turnDuration, setTurnDuration] = useState(15);
  const dispatch = useDispatch();
  useEffect(() => {
    if (selectedItem) {
      setTitle(selectedItem?.title);
      setStartDate(dayjs(selectedItem?.startDate));
      setEndDate(dayjs(selectedItem?.endDate));
      //   setAudio(selectedItem?.uri);
    }
  }, [selectedItem?._id]);

  const handleImageUpload = (file) => {
    setImage(file);
  };

  const handleSubmit = async () => {
    const payload = {
      title,
      startDate: new Date(startDate).toISOString(),
      endDate: new Date(endDate).toISOString(),
      turnDuration,
    };

    if (image) {
      payload["logo"] = image;
    }

    if (selectedItem?._id) {
      payload["id"] = selectedItem?._id;
    }
    try {
      dispatch(setLoading(true));
      if (!selectedItem?._id) {
        const resp = await AxiosInstance.post("/rap/create", payload);
        dispatch(showToast({ color: "success", msg: resp.data?.message }));
      } else {
        const resp = await AxiosInstance.put("/rap/edit", payload);
        dispatch(showToast({ color: "success", msg: resp.data?.message }));
      }
      handleCloseDialog();
      fetchList();
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setLoading(false));
    }
  };
  return (
    <Dialog
      sx={{
        zIndex: 9,
        "& .MuiDialog-container .MuiPaper-elevation": {
          borderRadius: "8px",
          width: "420px",
        },
      }}
      open={openDialog}
      onClose={handleCloseDialog}
    >
      <Box sx={{ padding: "20px 16px 0" }}>
        <DialogTitle
          sx={{ padding: "0 0 15px", textAlign: "center", fontWeight: 700 }}
        >
          {selectedItem ? "Edit" : "Add"} Battle
        </DialogTitle>
      </Box>
      <DialogContent sx={{ padding: "10px 16px 0" }}>
        <Box mt={1}>
          <CustomTextField
            label="Title of the audio"
            onChange={(e) => setTitle(e.target.value)}
            value={title}
            inputProps={{
              maxLength: 30,
              style: { color: "black" },
            }}
          />
        </Box>
        <Box sx={{ marginTop: "10px" }}>
          <Typography
            sx={{ fontWeight: 600, fontSize: "14px", marginBottom: "10px" }}
          >
            {" "}
            Upload Image{" "}
            <span
              style={{ fontSize: "10px", color: "gray", fontWeight: 400 }}
            >{`(File size max limit 5mb)`}</span>{" "}
          </Typography>
          <UploadBadge
            onImageUpload={handleImageUpload}
            edit={edit}
            audio={true}
            selectedBadge={selectedItem}
          />
        </Box>
        <Box>
          <label
            style={{
              color: "#828282",
              fontSize: "16px",
              position: "relative",
              top: "7px",
            }}
          >
            Submission Time
          </label>
          <DateTimeRangePicker
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={setStartDate}
            onEndDateChange={setEndDate}
          />
        </Box>
        <Box>
          <label
            style={{
              color: "#828282",
              fontSize: "16px",
              position: "relative",
              top: "7px",
            }}
          >
            Turn Duration
          </label>
          <br />
          <Select
            value={turnDuration}
            defaultValue={15}
            onChange={(e) => setTurnDuration(Number(e.target.value))}
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            sx={{ marginTop: "20px", width: "150px", color: "black" }}
          >
            <MenuItem value={15}>15 seconds</MenuItem>
          </Select>
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "0 16px 20px" }}>
        <OutlinedButton onClick={handleCloseDialog} btnName={"Cancel"} />
        <ContainedButton
          onClick={handleSubmit}
          btnName={selectedItem ? "Update" : "Add"}
        />
      </DialogActions>
    </Dialog>
  );
};
export default AddEditBattle;
